"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepperCurrentLabel = void 0;
var _ProgressStepperCurrentLabel = require("./ProgressStepperCurrentLabel");
// TODO: in v9, move styled() from ProgressStepperCurrentLabel.jsx to here
var StyledProgressStepperCurrentLabel = _ProgressStepperCurrentLabel.ProgressStepperCurrentLabel;
exports.StyledProgressStepperCurrentLabel = StyledProgressStepperCurrentLabel;